import axios from "axios";
import { API_BASE_URL_V2, API_BASE_URL_V3 } from "initializers/constants";
const distributeTests = (payload, groupBySpecs) => axios.post(`${groupBySpecs ? API_BASE_URL_V3 : API_BASE_URL_V2}/reporter/smart_orchestration/distribute_tests`, { smartOrchestration: payload });
const smartOrchestrationApi = { distributeTests };
export default smartOrchestrationApi;
//# sourceMappingURL=smartOrchestration.js.map